module.exports = __webpack_public_path__ + "img/huojian.85344f36.gif";